import type { HTMLAttributes } from 'react';
import type { VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/lib/utils/cn';
import { badgeVariants } from './Badge.variants';

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
